'use client';

import type { SearchResult } from 'conversational-search-client';
import { type JSX } from 'react';

import { JustifiedGallery, Text } from '@videoblocks/design-system';
import { Keep } from '@videoblocks/design-system/icons';

import { VideoResultCard } from './VideoResultCard';
import { deriveAspectRatio } from './deriveAspectRatio';

interface TopResultsSectionProps {
    results: SearchResult[];
}

export function TopResultsSection({ results }: TopResultsSectionProps): JSX.Element {
    const items = results.map((result) => ({
        ...result,
        id: result.contentId,
        aspectRatio: deriveAspectRatio(result.orientation),
    }));

    return (
        <section className="px-6 pt-4">
            <div className="flex flex-col gap-2 rounded-lg bg-white p-4">
                <div className="flex items-center gap-2">
                    <Keep width={16} height={16} className="shrink-0 [&_path]:fill-gray-800" />
                    <Text asChild fontSize="base" fontWeight="semibold" className="text-gray-800">
                        <h2>
                            Top {results.length} {results.length === 1 ? 'Result' : 'Results'}
                        </h2>
                    </Text>
                </div>
                <JustifiedGallery items={items} rowGapPx={8} columnGapPx={8}>
                    {({ item }) => <VideoResultCard result={item} />}
                </JustifiedGallery>
            </div>
        </section>
    );
}
